module.exports = __webpack_public_path__ + "img/fagh.ec25d3d6.png";